export const SECURITY_POLICY_ID_FIELDS = {
    SEC_POLICY_PWD_HISTORY_TOTAL: "SEC_POLICY_PWD_HISTORY_TOTAL",
    SEC_POLICY_ENFORCE_PWD_HISTORY: "SEC_POLICY_ENFORCE_PWD_HISTORY",
    SEC_POLICY_MIN_LENGTH: "SEC_POLICY_MIN_LENGTH",
    SEC_POLICY_ENFORCE_MIN_LENGTH: "SEC_POLICY_ENFORCE_MIN_LENGTH",
    SEC_POLICY_PWD_LIFETIME_MONTHS: "SEC_POLICY_PWD_LIFETIME_MONTHS",
    SEC_POLICY_ENFORCE_PWD_LIFETIME: "SEC_POLICY_ENFORCE_PWD_LIFETIME",
    SEC_POLICY_ENFORCE_SPECIAL_CHAR: "SEC_POLICY_ENFORCE_SPECIAL_CHAR",
    SEC_POLICY_ENFORCE_DIGITS: "SEC_POLICY_ENFORCE_DIGITS",
    SEC_POLICY_ENFORCE_LOWERCASE: "SEC_POLICY_ENFORCE_LOWERCASE",
    SEC_POLICY_ENFORCE_UPPERCASE: "SEC_POLICY_ENFORCE_UPPERCASE",
    SEC_POLICY_ENFORCE_INITIAL_PWD_CHANGE: "SEC_POLICY_ENFORCE_INITIAL_PWD_CHANGE",

    CERT_POLICY_ALIAS_NAME: "CERT_POLICY_ALIAS_NAME",
    CERT_POLICY_VALIDITY_YEAR_OR_DAY: "CERT_POLICY_VALIDITY_YEAR_OR_DAY",
    CERT_POLICY_VALIDITY_LIFETIME_VALUE: "CERT_POLICY_VALIDITY_LIFETIME_VALUE",
    CERT_POLICY_COMMON_NAME: "CERT_POLICY_COMMON_NAME",
    CERT_POLICY_SUBJECT_ALTERNATIVE_NAMES: "CERT_POLICY_SUBJECT_ALTERNATIVE_NAMES",
};

export const SECURITY_POLICY_SUB_TYPES = {
    CERT_SUB_TYPE_ID : 9,
    PASSWORD_SUB_TYPE_ID : 7,
}
